<template>
  <v-container fluid dark>
    <el-overlay-loading :loading="pageloading" />
    <h3 ref="topObjektas" class="mb-5">{{ turtasTitle }}</h3>

    <v-row no-gutters>
      <v-col cols="12" md="4">
        <el-money-field
          :readonly="!enableVerte || verteKita"
          :label="bendraVerteLabel"
          :tooltip="bendraVerteTooltip"
          hide-details
          v-model="formData.obj_bendra_objektu_verte"
        />
      </v-col>
      <v-col cols="12" md="4" class="pt-3 pl-3">
        <el-button
          :disabled="!enableVerte || verteKita"
          @click.native="copyVerte()"
          small
          >Kopijuoti suskaičiuotą</el-button
        >
      </v-col>
      <v-col cols="12" md="12" class="mt-3 " v-if="!isSutartis">
        <el-checkbox
          check-value="nenurodoma"
          :readonly="!enableVerte"
          :disabled="disabledVerteNenurodoma"
          label="Vertė šalių susitarimu nenurodoma"
          tooltip="Hipoteka. Turtas. Vertė šalių susitarimu nenurodoma"
          silent
          inline
          v-model="selectedVerte"
        />
        <el-checkbox
          class="ml-5"
          check-value="prievoleje"
          :readonly="!enableVerte"
          :disabled="disabledVertePrievoleje"
          :label="vertePrievolejeText"
          :tooltip="vertePrievolejeTooltip"
          silent
          inline
          v-model="selectedVerte"
        />
      </v-col>
    </v-row>

    <v-data-table
      class="mb-0 mt-5"
      :headers="headers"
      :items="itemsList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page.sync="pageSize"
      :search="search"
      :page.sync="page"
    >
      <template #top>
        <v-toolbar flat>
          <el-checkbox
            v-if="showIkeitimoTvarka"
            class="mr-5"
            label="Išieškojimo iš įkeitimo objektų tvarka nesvarbi"
            tooltip="Hipoteka. Turtas. Objektu tvarka nesvarbi"
            :readonly="!enableVerte"
            v-model="formData.obj_tvarka_nesvarbi"
          />
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button-prideti
            v-if="!isReadonlyForm && !isAntstolis"
            primary
            @click.native.stop="openTurtasRusis()"
          >
            Pridėti objektą
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template v-slot:body="props">
        <draggable
          v-model="props.items"
          tag="tbody"
          @update="dragItems(props.items)"
          :disabled="!enableDrag"
        >
          <tr
            v-for="(item, index) in props.items"
            :key="index"
            :class="rowClass(item)"
          >
            <td>
              <div class="nowrap">
                <v-icon v-if="enableDrag" small class="dragIcon mr-2">
                  mdi-arrow-up-down
                </v-icon>
                {{ item.eil_nr }}
              </div>
            </td>
            <td
              v-for="(data, index) in dataHeader"
              :key="index"
              :class="`text-${data.align}`"
            >
              <template v-if="data.value === 'tur_kita_informacija'">
                <div class="text-cut-4">
                  {{ item[data.value] }}
                </div>
              </template>
              <template v-else-if="data.value === 'tur_rusis_title'">
                {{ item[data.value] }}
                <template v-if="item.tur_ntr_tei_pabaigos_data">
                  <br />
                  <v-chip small outlined class="mt-1 mb-1">
                    Turtinė teisė išregistruota
                    {{ item.tur_ntr_tei_pabaigos_data }}
                  </v-chip>
                </template>
              </template>
              <template v-else>
                {{ item[data.value] }}
              </template>
            </td>
            <td class="text-center">
              <el-table-action
                :item="item"
                @searchItem="searchItem(item)"
                @reloadItem="reloadItem(item)"
                @editItem="editItem(item)"
                @viewItem="viewItem(item)"
                @deleteItem="deleteItem(item)"
                @restoreItem="restoreItem(item)"
              />
            </td>
          </tr>
        </draggable>

        <tbody>
          <tr class="visoRow">
            <td colspan="4" class="text-end"><strong>Iš viso:</strong></td>
            <td class="text-center">{{ formatVisoVerte }}</td>
            <td></td>
          </tr>
        </tbody>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <div ref="detailObjektas"></div>
    <template v-if="showTurtasObjektas">
      <v-divider class="mt-5" />
      <turtas-objektas
        :key="turtasComponentKey"
        :readonly="isReadonlyForm || isAntstolis"
        @closeTurtas="closeTurtas()"
      />
    </template>

    <template v-if="!showTurtasObjektas">
      <hipoteka-istorija duomenys="turtas" />

      <v-footer class="form-footer">
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="saveData()"
          :loading="loading"
          >Saugoti</el-button
        >
        <el-button
          v-if="!isReadonlyForm"
          @click.native="cancelData()"
          :loading="loading"
          >Atšaukti</el-button
        >
        <v-spacer></v-spacer>

        <el-button
          v-if="showNtrJson"
          @click.native="ntrJson()"
          :loading="loading"
          >NTR Json</el-button
        >
        <el-button
          v-if="showUzsakytiTikslinima"
          @click.native="ntrTikslinimas()"
          :loading="loading"
          >Užsakyti NT objektų tikslinimą sandoriui</el-button
        >
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="checkErrorsClick()"
          :loading="loading"
          >Tikrinti</el-button
        >
      </v-footer>
    </template>

    <modal-turtas-rusis
      :key="turtasRusisKey"
      v-model="showTurtasRusis"
      :items="filterTurtasRusisList"
      :no-davejas="noDavejas"
      @confirmTurtasRusis="confirmTurtasRusis"
    />
    <modal-ntr-tikslinimas v-model="showNtrTikslinimas" />
    <modal-delete
      title="Šalinti turtą?"
      :text="`Ar norite pašalinti turtą <strong>${modalDeleteVardas}</strong>?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import HipotekaMap from './../hipotekaMap'
import ModalTurtasRusis from '../../modals/ModalTurtasRusis'
import ModalDelete from '../../modals/ModalDelete'
import ModalNtrTikslinimas from '../../modals/ModalNtrTikslinimas'
import unsavedData from '../../../mixins/unsavedData'
import checkErrors from '../../../mixins/checkErrors'
import busena from '../../../mixins/busena'
import userRole from '../../../mixins/userRole'
import math from '../../../mixins/math'
import rowClass from '../../../mixins/rowClass'
import HipotekaIstorija from './../istorija/HipotekaIstorija'

const TurtasObjektas = () => import('./TurtasObjektas')

export default {
  name: 'HipotekaTurtas',
  components: {
    draggable,
    TurtasObjektas,
    ModalTurtasRusis,
    ModalNtrTikslinimas,
    ModalDelete,
    HipotekaIstorija,
  },
  mixins: [unsavedData, checkErrors, busena, userRole, math, rowClass],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      tableLoading: true,
      turtasRefresh: 0,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
      showTurtasRusis: false,
      turtasRusisRefresh: 0,
      modalTurtasRusisItems: null,
      showNtrTikslinimas: false,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      turtasRusisList: [],
      turtai: [],
      davejasCount: 0,
      formData: {
        obj_bendra_objektu_verte: 0,
        obj_tvarka_nesvarbi: false,
        reorder: [],
      },
      loadItem: {},
      autoSearch: null,
      autoSearchTurID: null,
      refreshTimer: null,
      selectedVerte: [],
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'turtasID',
      'turtasRusis',
      'hipotekaReadonly',
      'appSavitarna',
    ]),
    headers() {
      return [
        {
          text: this.headerEilNr,
          align: 'start',
          sortable: false,
          data: false,
          value: 'eil_nr',
        },
        {
          text: 'Turto ID',
          align: 'start',
          sortable: false,
          data: true,
          value: 'tur_tekstas',
        },
        {
          text: 'Turtas',
          align: 'start',
          sortable: false,
          data: true,
          value: 'tur_rusis_title',
        },
        {
          text: 'Kita informacija',
          align: 'start',
          sortable: false,
          data: true,
          value: 'tur_kita_informacija',
        },
        {
          text: 'Vertė, EUR',
          align: 'center',
          sortable: false,
          data: true,
          value: 'tur_verteFormat',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          data: false,
          value: 'load_status',
        },
      ]
    },
    headerEilNr() {
      return this.showIkeitimoTvarka && !this.formData.obj_tvarka_nesvarbi
        ? 'Išieškojimo tvarka'
        : 'Eil. Nr.'
    },
    isIkeitimas() {
      return this.hipotekaTipas.includes('ikeitimas')
    },
    isPakeitimas() {
      return this.hipotekaTipas.includes('pakeitimas')
    },
    showIkeitimoTvarka() {
      return this.isIkeitimas && this.isSavitarna
    },
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    filterTurtasRusisList() {
      return this.turtasRusisList.map(rusis => {
        return rusis
      })
    },
    turtasKitasTitle() {
      const key = Object.keys(HipotekaMap['turtasKitasTitle']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key
        ? HipotekaMap['turtasKitasTitle'][key].title
        : this.turtasKitasKey
    },
    turtasKitasKey() {
      return 'kitas'
    },
    turtasRusisKey() {
      return `rusis-${this.turtasRusisRefresh}`
    },
    turtasNtrKey() {
      return 'ntr'
    },
    loadingData() {
      const loadingItems = this.turtai.filter(item => {
        return item.tur_loaded === false
      })
      return loadingItems.length > 0 && this.$route.name === 'hipotekaTurtas'
    },
    refreshTimeout() {
      return HipotekaMap['TurtasRefreshTable']
    },
    dataHeader() {
      return this.headers.filter(item => {
        return item.data
      })
    },
    itemsList() {
      return this.turtai.map((item, index) => {
        item.eil_nr = index + 1
        item.tur_rusis_title =
          item.tur_rusis === this.turtasKitasKey
            ? this.turtasKitasTitle
            : item.tur_rusis_text //HipotekaMap['turtasTipas'][item.tur_rusis].title
        item.tur_verteFormat =
          item.tur_verte !== null ? this.moneyformat(item.tur_verte) : ''

        // if (index === 0) {
        //   item.tur_load_status = this.loadStatusPasikeite
        //   item.load_status = 'Pasikeitė'
        //   item.new = false
        // }

        item.showChip = item.tur_load_status !== this.loadStatusGauta
        item.chipColor =
          item.tur_load_status === this.loadStatusNerasta ||
          item.tur_load_status === this.loadStatusPasikeite
            ? 'red'
            : 'primary'

        if (!this.isReadonlyForm) {
          item.canSearch =
            item.tur_load_status === this.loadStatusPasikeite &&
            (item.new || !this.isPakeitimas)
          item.canReload =
            item.tur_load_status === this.loadStatusPasikeite &&
            !item.new &&
            this.isPakeitimas
          item.canView = !item.deleted && (item.canSearch || item.canReload)
          item.canEdit = !item.deleted && !item.canSearch && !item.canReload
          item.canDelete = !item.deleted
          item.canRestore =
            item.tevinis_id !== null && (item.deleted || item.edited)
        } else {
          item.canView = !item.deleted
        }
        return item
      })
    },
    visoVerte() {
      return this.turtai
        .map(item => (item.tur_verte > 0 && !item.deleted ? item.tur_verte : 0))
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
    },
    formatVisoVerte() {
      return this.moneyformat(this.visoVerte)
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    loadStatusNepradeta() {
      return 0
    },
    loadStatusPaleista() {
      return 1
    },
    loadStatusGauta() {
      return 2
    },
    loadStatusNerasta() {
      return 3
    },
    loadStatusNutraukta() {
      return 4
    },
    loadStatusPasikeite() {
      return 5
    },
    turtasComponentIndex() {
      return this.$route.params.turtasID > 0
        ? this.$route.params.turtasID
        : this.turtasRefresh
    },
    turtasComponentKey() {
      return `turtas-${this.turtasComponentIndex}`
    },
    turtasKey() {
      return Object.keys(HipotekaMap['turtasTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
    },
    turtasTitle() {
      const key = this.turtasKey
      return key ? HipotekaMap['turtasTekstas'][key].title : null
    },
    bendraVerteLabel() {
      const key = this.turtasKey
      return key ? HipotekaMap['turtasTekstas'][key].bendra_verte : null
    },
    bendraVerteTooltip() {
      const key = this.turtasKey
      return key ? HipotekaMap['turtasTekstas'][key].bendra_verteTooltip : null
    },
    showTurtasObjektas() {
      return this.$route.name === 'turtasObjektas'
    },
    enableDrag() {
      return (
        this.itemsList.length > 1 &&
        !this.search &&
        !this.showTurtasObjektas &&
        (this.isRengiamas || this.isGrazintas)
      )
    },
    enableVerte() {
      return !this.showTurtasObjektas && !this.isReadonlyForm
    },
    reorder() {
      return this.turtai.map(e => e.tur_id)
    },
    isNtrTurtas() {
      return (
        this.turtai.filter(item => {
          return item.tur_rusis === this.turtasNtrKey
        }).length > 0
      )
    },
    isAntstolis() {
      return this.role(['DT_antstolis'])
    },
    isPreprod() {
      return process.env.VUE_APP_PREPROD === 'true'
    },
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop'
      )
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    isSavitarna() {
      return this.appSavitarna
    },
    showNtrJson() {
      return (
        this.isNtrTurtas && this.role(['AD_administratorius']) && this.roleRG
      )
    },
    showUzsakytiTikslinima() {
      return (
        this.isNtrTurtas &&
        !this.isReadonlyForm &&
        this.roleOr(['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'])
      )
    },
    noDavejas() {
      return this.isSavitarna && this.davejasCount === 0
    },
    isSutartis() {
      return this.hipotekaTipas.includes('sutartis')
    },
    isSutartinis() {
      return this.hipotekaTipas.includes('sutartinis')
    },
    isPriverstinis() {
      return this.hipotekaTipas.includes('priverstinis')
    },
    vertePrievolejeText() {
      return this.isSutartinis
        ? 'Vertė nurodyta Užtikrintoje prievolėje'
        : 'Vertė nurodyta Užtikrintuose reikalavimuose'
    },
    vertePrievolejeTooltip() {
      return this.isSutartinis
        ? 'Hipoteka. Turtas. Vertė nurodyta Užtikrintoje prievolėje'
        : 'Hipoteka. Turtas. Vertė nurodyta Užtikrintuose reikalavimuose'
    },
    disabledVerteNenurodoma() {
      return this.selectedVerte.includes('prievoleje')
    },
    disabledVertePrievoleje() {
      return this.selectedVerte.includes('nenurodoma')
    },
    verteKita() {
      return this.selectedVerte.length > 0
    },
  },
  watch: {
    selectedVerte() {
      this.formData.obj_verte_nenurodoma = this.selectedVerte.includes(
        'nenurodoma'
      )
      this.formData.obj_verte_prievoleje = this.selectedVerte.includes(
        'prievoleje'
      )
      this.formData.obj_bendra_objektu_verte = null
    },
  },
  beforeCreate() {
    this.$root.$off('updateTurtasList')
  },
  created() {
    this.$root.$on('updateTurtasList', () => {
      this.getData()
    })
    this.ntrAtnaujinimas()
  },
  methods: {
    checkLoading() {
      if (this.loadingData) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            if (this.refreshTimer) {
              this.getData(false, false)
            }
          }, this.refreshTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    },
    ntrAtnaujinimas() {
      this.$axios
        .post(`objektas/${this.objektasID}/turtas/ntr-atnaujinimas`)
        .then(res => {
          //
        })
        .catch(err => {
          //
        })
        .finally(() => {
          this.getData(true)
        })
    },
    getData(firstLoad = false, loading = true) {
      this.pageloading = firstLoad
      this.loading = loading
      this.tableLoading = true
      this.$axios
        .get(`objektas/${this.objektasID}/turtas`)
        .then(res => {
          this.turtai = res.data.turtai
          this.turtasRusisList = res.data.turtasRusisList
          this.formData.obj_bendra_objektu_verte =
            res.data.obj_bendra_objektu_verte
          this.formData.obj_tvarka_nesvarbi = res.data.obj_tvarka_nesvarbi
          this.formData.obj_verte_nenurodoma = res.data.obj_verte_nenurodoma
          this.formData.obj_verte_prievoleje = res.data.obj_verte_prievoleje
          this.formData.reorder = this.reorder

          this.davejasCount = res.data.ikaitoDavejai

          if (this.formData.obj_verte_nenurodoma) {
            this.selectedVerte.push('nenurodoma')
          }
          if (this.formData.obj_verte_prievoleje) {
            this.selectedVerte.push('prievoleje')
          }

          if (this.$route.name === 'hipotekaTurtas') {
            this.initialForm()
          }
          this.checkLoading()
          this.$root.$emit('reloadHipotekaTab')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.tableLoading = false
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          const data = {
            obj_id: this.objektasID,
            ...this.formData,
          }

          this.$axios
            .post(`objektas/${this.objektasID}/turtas`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')

              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    updateTurtasList() {
      this.getData()
    },
    openTurtasRusis() {
      this.turtasRusisRefresh++
      this.showTurtasRusis = true
      this.autoSearch = null
      this.autoSearchTurID = null
    },
    confirmTurtasRusis(turtasRusis) {
      this.$root.$emit('checkDataChangedturtasObjektas')
      if (turtasRusis.irasomas && turtasRusis.key !== 'ntr') {
        this.openTurtasNew(turtasRusis)
      } else {
        this.openTurtasSearch(turtasRusis)
      }
    },
    openTurtasSearch(turtasRusis) {
      this.turtasRefresh++
      this.loadItem = {
        tur_id: 0,
        tur_rusis: turtasRusis.key,
      }
      this.openTurtas()
    },
    openTurtasNew(turtasRusis) {
      const data = {
        obj_id: this.objektasID,
        tur_id: 0,
        tipas: turtasRusis.key,
      }
      this.$axios
        .post(`objektas/${this.objektasID}/turtas/search`, data)
        .then(res => {
          this.loadItem = {
            tur_id: res.data.turtas.tur_id,
            tur_rusis: res.data.turtas.tur_rusis,
          }
          this.openTurtas()
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    searchItem(item) {
      this.autoSearch = item.tur_identifikatorius
      this.autoSearchTurID = item.tur_id
      this.loadItem = item
      this.openTurtas()
    },
    reloadItem(item) {
      this.loading = true

      this.$axios
        .post(
          `objektas/${this.objektasID}/turtas/${item.tur_id}/atnaujinti-pasikeitusi`
        )
        .then(res => {
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
        })
    },
    viewItem(item) {
      this.editItem(item)
    },
    editItem(item) {
      if (this.$route.params.turtasID !== item.tur_id) {
        this.loadItem = item
        this.autoSearch = null
        this.autoSearchTurID = null
        this.openTurtas()
      }
    },
    openTurtas() {
      this.stopLoading()
      const item = this.loadItem
      this.$router
        .push({
          name: 'turtasObjektas',
          params: {
            turtasID: this.autoSearch ? 0 : item.tur_id,
            turtasRusis: item.tur_rusis,
            autoSearch: this.autoSearch,
            autoSearchTurID: this.autoSearchTurID,
          },
        })
        .then(this.$vuetify.goTo(this.$refs.detailObjektas))
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.tur_identifikatorius ?? ''
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.$axios
        .delete(`objektas/${this.objektasID}/turtas/${item.tur_id}`)
        .then(res => {
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          if (this.$route.name !== 'hipotekaTurtas') {
            this.$router.push({
              name: 'hipotekaTurtas',
              params: {
                objektasID: this.objektasID,
              },
            })
          }
        })
    },
    restoreItem(item) {
      if (this.$route.params.turtasID === item.tur_id) {
        this.closeTurtas()
      }
      this.$axios
        .post(`objektas/${this.objektasID}/turtas/${item.tur_id}/restore`)
        .then(res => {
          this.getData()
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    closeTurtas() {
      this.$vuetify.goTo(this.$refs.topObjektas)
      this.$router.push({
        name: 'hipotekaTurtas',
        params: {
          objektasID: this.objektasID,
        },
      })
    },
    getActiveClass(item) {
      return this.$route.params.turtasID &&
        item.tur_id === this.$route.params.turtasID
        ? 'row-active'
        : ''
    },
    dragItems(items) {
      const pageSize = this.pageSize > 0 ? this.pageSize : items.length
      const startIndex = (this.page - 1) * pageSize

      this.turtai.splice(startIndex, pageSize, ...items)
      this.formData.reorder = this.reorder
    },
    ntrTikslinimas() {
      this.showNtrTikslinimas = true
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
    ntrJson() {
      this.$axios
        .get(`objektas/${this.objektasID}/ntrjson`)
        .then(res => {
          let fileData = res.data.json
          var fileURL = window.URL.createObjectURL(new Blob([fileData]))
          var fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', this.safeFileName('ntr.json'))
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    copyVerte() {
      this.formData.obj_bendra_objektu_verte = this.visoVerte
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
}
</script>
<style lang="scss" scoped>
.dragIcon {
  cursor: pointer;
}
.visoRow td {
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
